<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M22.8217 13.3208H24.4446V10.1408C24.1646 10.0975 23.2017 10 22.0803 10C19.7405 10 18.1377 11.6558 18.1377 14.6992V17.5H15.5557V21.055H18.1377V30H21.3033V21.0558H23.7809L24.1742 17.5008H21.3026V15.0517C21.3033 14.0242 21.5492 13.3208 22.8217 13.3208Z"
    fill={primary200}
  />
  <path
    d="M28.4446 26.5927C28.9355 26.5927 29.3334 26.1947 29.3334 25.7038C29.3334 25.2129 28.9355 24.8149 28.4446 24.8149C27.9536 24.8149 27.5557 25.2129 27.5557 25.7038C27.5557 26.1947 27.9536 26.5927 28.4446 26.5927Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24.8889 28.6664C25.3798 28.6664 25.7778 28.2685 25.7778 27.7776C25.7778 27.2866 25.3798 26.8887 24.8889 26.8887C24.398 26.8887 24 27.2866 24 27.7776C24 28.2685 24.398 28.6664 24.8889 28.6664Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M28.4446 30.7404C28.9355 30.7404 29.3334 30.3425 29.3334 29.8515C29.3334 29.3606 28.9355 28.9626 28.4446 28.9626C27.9536 28.9626 27.5557 29.3606 27.5557 29.8515C27.5557 30.3425 27.9536 30.7404 28.4446 30.7404Z"
    fill={primary200}
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.6562 28.2246L27.68 29.4039"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M27.677 26.1509L25.6562 27.3301"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
